import { SuretyAccountId, SuretyIndemnityAgreementId } from "@inrev/common";
import { useFlags } from "@portal/providers/GlobalFlagsProvider";
import { useQuery } from "@tanstack/react-query";
import { downloadFileFromDataString } from "../../../utils/download";
import { useRequest } from "../../../utils/request";

export const useAdminGetAccountIndemnityAgreementFileUrl = (
	accountId: SuretyAccountId,
	indemnityAgreementId: SuretyIndemnityAgreementId,
	asDownload?: boolean,
) => {
	const { get } = useRequest();
	const { showErrorFlag } = useFlags();

	const { data, error, isLoading, refetch } = useQuery({
		queryKey: [
			"accounts",
			accountId,
			"indemnity-agreements",
			indemnityAgreementId,
			{ download: asDownload },
		],
		queryFn: async () =>
			await get<string>(
				`/v2/admin/surety/accounts/${accountId}/indemnity-agreements/${indemnityAgreementId}?download=${asDownload ?? false}`,
				undefined,
				"text",
			),
		retry: false,
		staleTime: 60000,
		enabled: false,
	});

	const downloadIndemnityAgreement = () => {
		refetch().then(({ data, isError }) => {
			if (data) {
				downloadFileFromDataString(data);
			} else if (isError) {
				showErrorFlag({ message: "Failed to download indemnity agreement" });
			}
		});
	};

	return {
		downloadIndemnityAgreement,
		getIndemnityAgreementFileUrl: refetch,
		indemnityAgreementFileUrl: data,
		indemnityAgreementFileUrlError: error,
		indemnityAgreementFileUrlLoading: isLoading,
	};
};
